import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFoundPage() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language === "en" ? "en" : "pe";
  return (
    <section
      className="max-w-3xl mx-auto px-6 py-24 text-center"
      data-testid="notfound-page"
    >
      <h1
        className="text-5xl text-slate-900"
        style={{ fontFamily: "Merriweather, serif", fontWeight: 700 }}
      >
        {t("not_found.title")}
      </h1>
      <p className="mt-4 text-slate-700">{t("not_found.body")}</p>
      <Link
        to={`/${lang}`}
        className="mt-8 inline-flex items-center rounded-md px-6 py-3 text-white font-semibold"
        style={{ backgroundColor: "#0B1D3A" }}
        data-testid="notfound-back"
      >
        {t("not_found.back")}
      </Link>
    </section>
  );
}
